const {h, render, Component} = require('preact');
const queryString = require('qs');
const SupportAPIHelper = require('../../../../../support/frontend/helpers/API')
const Search = require('./search')
const SearchResults = require('./search_results')
const SpinnerView = require('../../views/common/spinner')
const ErrorView = require('../main/error')
const Helper = require('./helper')
const SessionHelper = require('../../../helper')

class ContextualSearchBar extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.setState({searchText: undefined, contextualSearchResults: null})
  }

  handleSearch(searchText){
    let inbentaParams = this.props.inbentaParams;
    inbentaParams.query = searchText;
    let inbentaSessionToken = sessionStorage.getItem('inbentaSessionKey')

    if (inbentaSessionToken !== null && inbentaSessionToken != undefined) {
      inbentaParams.inbentaSessionToken = inbentaSessionToken
    }
    else {
      SessionHelper.createSession()
    }

    let qs = queryString.stringify(inbentaParams)
    let CONTEXTUAL_SEARCH = `${Groupon.Utils.getConfigFromDom().FAQBASEURL}/contextual_search?${qs}`;
    let errorCb = () => {
      this.setState({contextualSearchResults: null, isSearching: false, 'isFailure': true});
    }
    let successCb = (response) => {
      if(response)
      {
        this.setState({contextualSearchResults: response, searchText: searchText, isSearching: false});
      }
    }
    this.setState({contextualSearchResults: null, isSearching: true})
    SupportAPIHelper.get(CONTEXTUAL_SEARCH, null, successCb, errorCb, false);
  }

  render() {
    let searchResultsComponent = null;
    Helper.closeOpenedArticles();
    if (this.state.contextualSearchResults){
      searchResultsComponent = <SearchResults
          results={this.state.contextualSearchResults}
          searchText={this.state.searchText} handleNeedHelpFromSearchResults={this.props.handleNeedHelpFromSearchResults}
      />;
    }
    if (this.state.isFailure)
      return (<ErrorView/>)
    return (
        <div>
          <p class="contextual-search-bar-above-text" >
            {I18n.translate("js.modules.web_2018.need_help_with_this_groupon")}
          </p>
          <Search handleSearch = {this.handleSearch.bind(this)}/>
          {searchResultsComponent}
          {this.state.isSearching && <SpinnerView/>}
        </div>
    )
  }
}

module.exports = ContextualSearchBar